import styled from 'styled-components';

export const TagSection = styled.section`
  @media (min-width: 768px) {
    grid-column: 1 / 3;
  }
`;

export const TagHeader = styled.div`
  margin-bottom: 20px;
  
  @media (min-width: 768px) {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

export const TagHeading = styled.h2`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 22px;
  line-height: 1;
  
  @media (min-width: 768px) {
    margin-bottom: 15px;
    
    font-size: 24px;
  }
`;

export const TagDescription = styled.p`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;
  
  font-size: 12px;
  line-height: 16px;
  
  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 20px;
  }
  
  a {
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
`;

export const TagButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 15px 30px;
  
  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: ${({ theme }) => theme.blue};
  
  box-shadow: inset 0 0 0 2px ${({ theme }) => theme.blue};
  border-radius: 50px;
  
  transition: color 0.3s, box-shadow 0.3s;
  cursor: pointer;
  
  svg {
    flex-shrink: 0;
    margin-right: 10px;
    
    fill: currentColor;
    
    transition: fill 0.3s;
  }
  
  &:hover {
    color: ${({ theme }) => theme.white};
    background-image: linear-gradient(159.02deg, #2DB9FE 0%, #4EDBFC 100%);
    box-shadow: 0 8px 20px rgba(30, 182, 255, 0.24);
  }
  
  @media (min-width: 768px) {
    max-width: 240px;
    padding: 15px;
  }
`;

export const TagWidget = styled.div`
  
  iframe {
    width: 100%;
    height: 410px;
    border: none;
    
    @media (min-width: 500px) {
      height: 515px;
    }
  }
`;
